import React, { useState } from "react";
import {
  StyleSheet,
  View,
  Dimensions,
  Pressable,
  Linking,
  ActivityIndicator,
} from "react-native";
const { width } = Dimensions.get("window");
import Image from "@d11/react-native-fast-image";
import analytics from "@services/analytics";
import { actions as authActions } from "@reducers/authReducer";
import LogoCarousel from "@assets/svg/LogoCarouserl.js";
import YouTubeIcon from "@assets/svg/YouTubeIcon.js";
import CustomText from "@components/CustomText";
import Carousel from "react-native-looped-carousel";
import t from "@constants/localization";
import { useDispatch, useSelector } from "react-redux";
import { actions as configActions } from "../../reducers/configReducer";
import { CAROUSEL_WALKTHROUGH } from "@constants/analyticsEventsCT";
const PATH = "components/onBoarding/WalkThrough";

// const openUrl = async (video_id) => {
//   const vndUrl = `vnd.youtube://${video_id}`;
//   const normalUrl = `https://www.youtube.com/watch?v=${video_id}`;

const openUrl = async () => {
  const vndUrl =
    "vnd.youtube://playlist?list=PLDCS14Lb2xpb5D0B5oSegn3MHC96PIh9j";
  const normalUrl =
    "https://www.youtube.com/playlist?list=PLDCS14Lb2xpb5D0B5oSegn3MHC96PIh9j";
  Linking.canOpenURL(vndUrl).then((supported) => {
    if (supported) {
      return Linking.openURL(vndUrl);
    } else {
      return Linking.openURL(normalUrl);
    }
  });
};

const CrouselWalkthrough = () => {
  const dispatch = useDispatch();
  const setActiveIndex = (index) => {
    setIndex(index);
  };
  const [autoplay, setAutoPlay] = useState(true);
  const [loading, setLoading] = useState(false);

  const {
    WALKTHROUGH: { images = [] },
  } = useSelector((state) => state.configReducer.appSettings);

  const handleYouTubeLink = () => {
    analytics.trackEvent(CAROUSEL_WALKTHROUGH.YOUTUBE_LINK_CLICKED);
    openUrl();
  };

  const handleSkip = (isLast) => {
    setLoading(true);
    // dispatch(authActions.restoreUserToken(true));
    dispatch(configActions.syncUser()); // --> call sync
    if (isLast) {
      analytics.trackEvent(CAROUSEL_WALKTHROUGH.GET_STARTED);
    } else {
      analytics.trackEvent(CAROUSEL_WALKTHROUGH.WALKTHORUGH_SKIPPED, {
        carousel_number: index + 1,
      });
    }
  };

  const [index, setIndex] = useState(0);

  const handlePressIn = () => {
    setAutoPlay(false);
  };

  const handlePressOut = () => {
    setAutoPlay(true);
  };

  return (
    <>
      <View style={styles.headerContainer}>
        <LogoCarousel />
        {index < 2 ? (
          <Pressable onPress={() => handleSkip(false)}>
            <CustomText variant="entityHeading" style={styles.skip}>
              {t(`${PATH}/skip`)}
            </CustomText>
          </Pressable>
        ) : loading ? (
          <ActivityIndicator size={"small"} color="#E40046" />
        ) : (
          <></>
        )}
      </View>

      <View style={{ flex: 1, backgroundColor: "white" }}>
        <Carousel
          bullets={true}
          bulletStyle={styles.nonActiveBullet}
          chosenBulletStyle={styles.activeBullet}
          style={{ flex: 1 }}
          autoplay={autoplay}
          swipe={true}
          delay={5000}
          onAnimateNextPage={setActiveIndex}
        >
          {images.map((imagearr) => {
            if (!Array.isArray(imagearr)) {
              const { image, width, height } = imagearr;
              return (
                <Pressable
                  onPressOut={handlePressOut}
                  onPressIn={handlePressIn}
                  style={{ flex: 1 }}
                >
                  <Image
                    resizeMode="contain"
                    style={{ width, height }}
                    source={{ uri: image }}
                  />
                  {index === 0 ? (
                    <View
                      style={{
                        paddingHorizontal: 16,
                      }}
                    >
                      <Pressable onPress={handleYouTubeLink}>
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <View style={{ marginLeft: 4 }}>
                            <YouTubeIcon />
                          </View>
                          <CustomText style={styles.youTubeText}>
                            {t(`${PATH}/clickOnYouTube`)}
                          </CustomText>
                        </View>
                      </Pressable>
                    </View>
                  ) : null}
                </Pressable>
              );
            }
            return (
              <Pressable
                onPressOut={handlePressOut}
                onPressIn={handlePressIn}
                style={{ flex: 1 }}
              >
                {imagearr.map((data, i) => {
                  const { image, width, height } = data;
                  return (
                    <Image
                      resizeMode="contain"
                      style={{ width, height }}
                      source={{ uri: image }}
                    />
                  );
                })}
                {index === 2 ? (
                  <Pressable
                    onPress={() => handleSkip(true)}
                    style={{
                      marginHorizontal: 12,
                      paddingVertical: 12,
                      backgroundColor: "#E40046",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <View style={{ flexDirection: "row" }}>
                      {!loading ? (
                        <CustomText
                          variant="entityHeading"
                          style={styles.earnNow}
                        >
                          {t(`${PATH}/earnNow`)}
                        </CustomText>
                      ) : (
                        <ActivityIndicator size={"small"} color="white" />
                      )}
                    </View>
                  </Pressable>
                ) : null}
              </Pressable>
            );
          })}
        </Carousel>
      </View>
    </>
  );
};

export default CrouselWalkthrough;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "white",
    alignItems: "center",
  },
  nonActiveBullet: {
    height: 5,
    width: width / 3 - 15,
    borderRadius: 50,
    marginHorizontal: 3,
    backgroundColor: "rgba(228, 0, 70, 0.1)",
    borderWidth: 0,
  },
  activeBullet: {
    height: 5,
    width: width / 3 - 15,
    backgroundColor: "#E40046",
    marginHorizontal: 3,
  },
  headerContainer: {
    paddingHorizontal: 16,
    paddingVertical: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "white",
  },
  image: {
    width: width,
    resizeMode: "contain",
  },
  youtube: {
    flexDirection: "row",
    backgroundColor: "white",
    paddingHorizontal: 15,
  },
  youTubeText: {
    marginLeft: 5,
    marginTop: 2,
    color: "#E40046",
    fontSize: 14,
    lineHeight: 20,
    flex: 1,
  },
  earnNow: {
    color: "white",
    textAlign: "center",
    marginBottom: 0,
  },
  skip: {
    justifyContent: "center",
    color: "#E40046",
    paddingHorizontal: 0,
    marginBottom: 0,
  },
});
